export default __webpack_public_path__ + "static/media/back-btn.dd7191ab.svg";